<template>
	<section>
		<div class="top">
			<el-badge :value="this.productCount" :max="99" type="primary">
				<el-button size="mini" @click="customerProductLastest($route.params.id)">{{ $t("productHistory.materialChange") }}</el-button>
			</el-badge>
			<el-button style="margin-left: 20px" size="mini" @click="importGoodsVisible = true">{{ $t("productHistory.codingImportGoods") }}</el-button>
			<el-input
				style="float: right; width: 200px"
				class="search"
				clearable
				v-model="keyword"
				size="mini"
				:placeholder="this.$t('productHistory.aliasSearch')"
			></el-input>
		</div>

		<el-table ref="productsTable" :data="filterHistoryProducts" style="width: 100%" :empty-text="this.$t('productHistory.noData')">
			<el-table-column prop="name" :label="this.$t('productHistory.productName')"></el-table-column>
			<el-table-column prop="alias" :label="this.$t('productHistory.productAlias')"></el-table-column>
			<el-table-column
				prop="category_name"
				:label="this.$t('productHistory.category')"
				:filters="filterCategoryName"
				:filter-method="filterCategory"
			></el-table-column>
			<el-table-column
				prop="status"
				:label="this.$t('productHistory.state')"
				:filters="[
					{ text: this.$t('productHistory.enable'), value: 1 },
					{ text: this.$t('productHistory.disable'), value: 0 },
				]"
				:filter-method="filterStatus"
			>
				<template slot-scope="scope">
					<span>{{ scope.row.status ? $t("productHistory.enable") : $t("productHistory.disable") }}</span>
				</template>
			</el-table-column>
			<el-table-column prop="cz" :label="this.$t('productHistory.operate')">
				<template slot-scope="scope">
					<el-button size="mini" @click="handleEdit(scope.row)">{{ $t("productHistory.edit") }}</el-button>
				</template>
			</el-table-column>
		</el-table>

		<!-- 导入商品弹出框 -->
		<el-dialog
			:title="this.$t('productHistory.importProducts')"
			class="import-goods-box"
			:visible.sync="importGoodsVisible"
			width="60%"
			:before-close="handleCloseImportGoods"
		>
			<el-steps :active="importGoodsActive" finish-status="success" style="margin-bottom: 20px">
				<el-step :title="this.$t('productHistory.enterCustomerCode')"> </el-step>
				<el-step :title="this.$t('productHistory.selectProduct')"></el-step>
				<el-step :title="this.$t('productHistory.finish')"></el-step>
			</el-steps>

			<!-- 步骤1输入客户编码 -->
			<div class="step" v-show="importGoodsActive === 0 ? true : false">
				<el-form :model="importGoods" ref="importGoodsRef" :rules="rules" class="import-goods-content" v-loading="loading">
					<el-form-item :label="this.$t('productHistory.customerCode')" prop="referenceCustomerId">
						<el-input v-model="importGoods.referenceCustomerId" style="width: 200px; margin-left: 10px" size="mini" required @input="handleInput">
						</el-input>
					</el-form-item>
					<el-form-item class="step-btn">
						<el-button type="primary" @click="handleNextStep" size="mini">{{ $t("productHistory.nextStep") }}</el-button>
					</el-form-item>
				</el-form>
			</div>
			<!-- 步骤2选择商品 -->
			<div v-show="importGoodsActive === 1 ? true : false" v-loading="loading">
				<el-input
					style="width: 200px; margin-bottom: 10px"
					class="search"
					clearable
					v-model="importGoodsKeyword"
					size="mini"
					:placeholder="this.$t('productHistory.aliasSearch')"
				></el-input>
				<el-table
					ref="productsTable"
					:data="filterImportGoodsHistoryProducts"
					tooltip-effect="dark"
					@selection-change="handleSelectHistoryGoods"
					style="width: 100%"
					:empty-text="this.$t('productHistory.noData')"
					class="step"
				>
					<el-table-column type="selection" width="55"> </el-table-column>
					<el-table-column prop="name" width="300" :label="this.$t('productHistory.productName')"></el-table-column>
					<el-table-column prop="alias" width="300" :label="this.$t('productHistory.productAlias')"></el-table-column>
					<el-table-column
						prop="category_name"
						:label="this.$t('productHistory.category')"
						:filters="filterCategoryName"
						:filter-method="filterCategory"
					></el-table-column>
					<el-table-column
						prop="status"
						:label="this.$t('productHistory.state')"
						:filters="[
							{ text: this.$t('productHistory.enable'), value: 1 },
							{ text: this.$t('productHistory.disable'), value: 0 },
						]"
						:filter-method="filterStatus"
					>
						<template slot-scope="scope">
							<span>{{ scope.row.status ? $t("productHistory.enable") : $t("productHistory.disable") }}</span>
						</template>
					</el-table-column>
				</el-table>
				<div class="step-btn" style="margin-top: 15px">
					<el-button @click="toggleSelection()" size="mini">{{ $t("productHistory.cancelSelection") }}</el-button>
					<el-button type="primary" @click="handleLastStep" size="mini">{{ $t("productHistory.previous") }}</el-button>
					<el-button type="primary" @click="handleToLead" size="mini">{{ $t("productHistory.import") }}</el-button>
				</div>
			</div>
			<!-- 步骤3完成 -->
			<div class="step" v-show="importGoodsActive === 3">
				<div class="complete-message">
					<div v-if="Object.keys(succeedImportGoods).length > 0 && Object.keys(succeedImportGoods.imported_products).length > 0">
						<el-tag v-for="(item, index) in succeedImportGoods.imported_products" :key="index">{{ item.name }}</el-tag>
						<p class="successful">
							<span>{{ $t("productHistory.aTotalOf") }}</span
							>{{ Object.keys(succeedImportGoods.imported_products).length }}<span>{{ $t("productHistory.productImportSuccess") }}</span>
						</p>
					</div>
					<div v-if="Object.keys(succeedImportGoods).length > 0 && Object.keys(succeedImportGoods.existing_products).length > 0">
						<el-tag type="danger" class="el-tag" v-for="(item, index) in succeedImportGoods.existing_products" :key="index">{{ item.name }}</el-tag>
						<p class="failure">
							<span>{{ $t("productHistory.aTotalOf") }}</span
							>{{ Object.keys(succeedImportGoods.existing_products).length }}<span>{{ $t("productHistory.productImportFailure") }}</span>
						</p>
					</div>
				</div>
				<div class="step-btn" style="margin-top: 15px">
					<el-button type="primary" @click="handleFinishsLastStep" size="mini">{{ $t("productHistory.previous") }}</el-button>
					<el-button type="primary" @click="handleCloseImportGoods" size="mini">{{ $t("productHistory.finish") }}</el-button>
				</div>
			</div>
		</el-dialog>
		<!-- 商品编辑 -->
		<ProductEdit
			:editProductDialogFormVisible="editProductDialogFormVisible"
			:editProductDialogForm="editProductDialogForm"
			:attributeOptions="attributeOptions"
			@handle-close-edit-product="handleCloseEditProduct"
			@handle-confirm-product-edit="handleConfirmProductEdit"
			@handle-update-specification="handleUpdateSpecification"
		></ProductEdit>
	</section>
</template>
<script>
import ProductEdit from "./product-edit.vue";
import { getCustomerHistoryPorduct, postImportHistoryByCustomer } from "@/services/api-v2/api-v2";

export default {
	components: {
		ProductEdit,
	},

	props: {
		productCount: {
			type: Number,
			required: true,
			default: 0,
		},
		historyProducts: {
			type: Array,
			required: true,
			default: [],
		},
		attributeOptions: {
			type: Array,
			required: true,
			default: [],
		},
	},

	data() {
		return {
			//搜索关键词
			keyword: "",

			//导入商品时关键词搜索
			importGoodsKeyword: "",

			// 编辑商品弹出框
			editProductDialogFormVisible: false,

			// 编辑商品表单数据
			editProductDialogForm: {
				productId: "",
				name: "",
				alias: "",
				categoryName: "",
				attributeOptions: [],
				selectedAttributes: [],
				status: null,
				index: "",
			},

			// 加载中
			loading: false,

			// 导入商品弹出框
			importGoodsVisible: false,

			// 导入商品步骤条active
			importGoodsActive: 0,

			// 导入商品信息
			importGoods: {
				// 参考客户编码
				referenceCustomerId: "",
				// 客户历史商品
				customerHistoryGoods: [],
			},

			// 表单验证规则
			rules: {
				referenceCustomerId: [{ required: true, message: this.$t("productHistory.pleaseEnterCustomerCode"), trigger: "blur" }],
			},

			// 选择要导入的历史商品
			selectHistoryGoods: [],

			// 导入成功历史商品信息
			succeedImportGoods: {},
		};
	},
	computed: {
		// historyProducts 数据模糊搜索
		filterHistoryProducts() {
			if (this.keyword) {
				return this.historyProducts.filter((data) => {
					return (
						(data.alias && data.alias.toLowerCase().includes(this.keyword.toLowerCase())) ||
						data.name.toLowerCase().includes(this.keyword.toLowerCase())
					);
				});
			}
			return this.historyProducts;
		},

		// historyProducts 导入商品时数据模糊搜索
		filterImportGoodsHistoryProducts() {
			if (this.importGoodsKeyword) {
				return this.importGoods.customerHistoryGoods.filter((data) => {
					return (
						(data.alias && data.alias.toLowerCase().includes(this.importGoodsKeyword.toLowerCase())) ||
						data.name.toLowerCase().includes(this.importGoodsKeyword.toLowerCase())
					);
				});
			}
			return this.importGoods.customerHistoryGoods;
		},

		//筛选类别数据
		filterCategoryName() {
			return _.map(_.groupBy(this.historyProducts, "category_name"), (_item, key) => ({ text: key, value: key }));
		},

		//导入商品时筛选类别数据
		filterimportGoodsCategoryName() {
			return _.map(_.groupBy(this.importGoods.customerHistoryGoods, "category_name"), (_item, key) => ({ text: key, value: key }));
		},
	},

	methods: {
		// 关闭编辑弹出框
		handleCloseEditProduct() {
			this.editProductDialogFormVisible = false;
		},

		// 商品信息编辑
		handleEdit(data) {
			this.editProductDialogFormVisible = true;
			this.editProductDialogForm.productId = data.id;
			this.editProductDialogForm.name = data.name;
			this.editProductDialogForm.alias = data.alias;
			this.editProductDialogForm.categoryName = data.category_name;
			this.editProductDialogForm.attributeOptions = data.attribute_options.map((item) => item.id);
			this.editProductDialogForm.status = data.status;
			this.editProductDialogForm.selectedAttributes = data.selected_attributes;
			this.editProductDialogForm.index = this.productAllData.findIndex((item) => {
				return item.id === data.id;
			});
		},

		// 添加规格
		handleUpdateSpecification() {
			this.$emit("handle-update-specification");
		},

		//确定编辑
		handleConfirmProductEdit(data) {
			this.$emit("handle-confirm-product-edit", data);
		},

		// 跳转同步设置
		customerProductLastest(customerId) {
			this.$router.push({ path: `/setting/customer-product-lastest/${customerId}` });
		},

		// 类别筛选
		filterCategory(value, row) {
			return row.category_name === value;
		},

		// 状态筛选
		filterStatus(value, row) {
			return row.status === value;
		},

		//输入客户编码input事件
		handleInput(value) {
			if (isNaN(value)) {
				this.importGoods.referenceCustomerId = "";
			}
		},

		// 导入商品下一步
		handleNextStep() {
			const customerId = "0000" + this.importGoods.referenceCustomerId;
			this.$refs.importGoodsRef.validate(async (valid) => {
				if (valid) {
					try {
						this.loading = true;
						const { data } = await getCustomerHistoryPorduct(customerId);
						this.importGoods.customerHistoryGoods = data.products;
						if (this.importGoodsActive++ > 2) {
							this.importGoodsActive = 0;
						}
					} catch (error) {
						this.$message.error(error);
					} finally {
						this.loading = false;
					}
				} else {
					this.$message.error(this.$t("productHistory.messageInformationCorrectly")); // 弹出错误提示
					return false;
				}
			});
		},
		// 取消已选择要导入的商品
		toggleSelection(rows) {
			if (rows) {
				rows.forEach((row) => {
					this.$refs.productsTable.toggleRowSelection(row);
				});
			} else {
				this.$refs.productsTable.clearSelection();
			}
		},

		// 导入商品上一步
		handleLastStep() {
			if (this.importGoodsActive-- < 0) {
				this.importGoodsActive = 0;
			}
		},

		// 完成导入商品上一步
		handleFinishsLastStep() {
			this.importGoodsActive = 1;
		},

		// 关闭导入商品弹出框
		handleCloseImportGoods() {
			this.$refs.importGoodsRef.resetFields();
			this.importGoodsVisible = false;
			this.importGoodsActive = 0;
		},

		// 选择要导入的历史商品
		handleSelectHistoryGoods(val) {
			this.selectHistoryGoods = val;
		},

		// 导入选择的历史商品
		async handleToLead() {
			const customerId = "0000" + this.importGoods.referenceCustomerId;
			if (this.selectHistoryGoods.length > 0) {
				try {
					this.loading = true;
					let productIds = this.selectHistoryGoods.map((item) => item.id);
					const { data } = await postImportHistoryByCustomer(this.$route.params.id, customerId, productIds);
					this.succeedImportGoods = data;
					this.importGoodsActive = 3;
				} catch (error) {
					this.$message.error(error);
				} finally {
					this.loading = false;
				}
			} else {
				this.$message.error(this.$t("productHistory.pleaseSelectProduct"));
			}
		},
	},
};
</script>
<style scoped>
.top {
	padding-top: 10px;
}

.step {
	height: 400px;
	overflow: auto;
	box-sizing: border-box;
}
.import-goods-content {
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
}
.complete-message {
	height: 350px;
	overflow: auto;
	box-sizing: border-box;
}
.step-btn {
	display: flex;
	justify-content: flex-end;
	margin-bottom: 0 !important;
}
.el-tag {
	margin: 0 10px 10px 0;
}
.successful {
	color: #409eff;
	padding-left: 10px;
}
.failure {
	color: #f56c6c;
	padding-left: 10px;
}
.import-goods-box /deep/ .el-dialog {
	min-width: 700px !important;
}
</style>
